import { plainToInstance } from 'class-transformer'
import { Entity } from '@core/entities/entity'
import { IRegisterView } from './IRegisterView'
import { RegisterViewProperty } from '../RegisterViewProperty'

export class RegisterView extends Entity<IRegisterView> {
  id: number
  modifiedOn: string
  name: string
  description: string
  properties?: RegisterViewProperty[]

  public static new(payload: unknown): RegisterView {
    const entity = plainToInstance(RegisterView, payload)

    return entity
  }
}
